import {createReducer} from '@reduxjs/toolkit'
import {WidgetComponentConfig} from '../../types'
import {updateStyleParams} from '../actions/component'

const defaultState: WidgetComponentConfig = {} as WidgetComponentConfig

export const component = createReducer(defaultState, builder =>
  builder.addCase(updateStyleParams, (state, {payload}) => {
    state.settings = {
      ...state.settings,
      ...payload.numbers,
      ...payload.booleans,
    }
  }),
)
